var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"py-6",attrs:{"border":"top","prominent":"","type":"error","icon":"mdi-close-octagon"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }